import WeatherHealthBadge from "./WeatherHealthBadge";
import { formatDateTime } from "../../users/adminUserFormatters";

function MetricRow({ label, value }) {
  if (value === undefined || value === null || value === "") {
    return null;
  }

  return (
    <div className="weather-source-detail__metric">
      <span className="weather-source-detail__metric-label">{label}</span>
      <span className="weather-source-detail__metric-value">
        {typeof value === "object" ? JSON.stringify(value) : String(value)}
      </span>
    </div>
  );
}

const WeatherSourceHealthCheckResult = ({ result }) => {
  if (!result) {
    return null;
  }

  const health = result.result || result;
  const status = health.status || health.healthCheckStatus || health.healthStatus;

  return (
    <section className="weather-source-detail__section weather-source-health-check-result">
      <h3>Latest health check</h3>
      <div className="weather-source-detail__status-row">
        <WeatherHealthBadge status={status} />
      </div>
      {health.message ? (
        <p className="weather-source-detail__message">{health.message}</p>
      ) : null}
      <MetricRow label="Checked at" value={formatDateTime(health.checkedAt || health.lastCheckedAt)} />
      <MetricRow
        label="Response time"
        value={
          health.responseTimeMs != null ? `${health.responseTimeMs} ms` : "—"
        }
      />
      <MetricRow label="Configured" value={health.isConfigured ? "Yes" : "No"} />
      <MetricRow
        label="Healthy"
        value={health.isHealthy === undefined ? "—" : health.isHealthy ? "Yes" : "No"}
      />
      <MetricRow
        label="Layer ID"
        value={health.arcgis?.configuredLayerId ?? health.metadata?.arcgis?.configuredLayerId ?? "—"}
      />
      <MetricRow
        label="Layer name"
        value={health.arcgis?.configuredLayerName ?? health.metadata?.arcgis?.configuredLayerName ?? "—"}
      />
      <MetricRow label="Map name" value={health.arcgis?.mapName} />
      <MetricRow label="Layer count" value={health.arcgis?.layerCount} />
      {health.warnings?.length ? (
        <MetricRow label="Warnings" value={health.warnings.join("; ")} />
      ) : null}
      {health.errors?.length ? (
        <MetricRow label="Errors" value={health.errors.join("; ")} />
      ) : null}
      {health.endpoint?.metadataUrl ? (
        <MetricRow label="Metadata URL" value={health.endpoint.metadataUrl} />
      ) : null}
    </section>
  );
};

export default WeatherSourceHealthCheckResult;
